module.exports = __webpack_public_path__ + "img/sneaker-combat.6c119c53.png";